import { controls } from "../../controls";
const rprbi10 = {
  label: "Digital Transaction",
  starting: true,
  url: "Digital Transaction",
  pageLabel: "Digital Transaction",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.magicDateLabel({ tab: "filter", label: "As On Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "n" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "RBI Digital Transaction",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },

    textReportProps: {
      'LBS': {
        filename: `RBI-Digital_Transaction-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    displayColumns: [
      {
        Header: "Branch Code",
        accessor: "branch_code",
      },
      {
        Header: "Branch Name",
        accessor: "branch_display",
      },
      {
        Header: "BHIM UPI A/C",
        accessor: "bhim_ac",
      },
      {
        Header: "BHIM UPI Amount",
        accessor: "bhim_amount",
      },
      {
        Header: "BHIM Aadhaar A/c",
        accessor: "bhim_a_ac",
      },
      {
        Header: "BHIM Aadhaar Amount",
        accessor: "bhim_a_amt",
      },
      {
        Header: "Bharat QR Code A/c",
        accessor: "bharatqrcnt",
      },
      {
        Header: "Bharat QR Code Amount",
        accessor: "bharatqramt",
      },
      {
        Header: "IMPS A/c",
        accessor: "impscnt",
      },
      {
        Header: "IMPS Amount",
        accessor: "impsamt",
      },
      {
        Header: "Cards (Debit & Credit) A/c",
        accessor: "cardscnt",
      },
      {
        Header: "Cards (Debit & Credit) Amount",
        accessor: "cardsamt",
      },
      {
        Header: "USSD A/c",
        accessor: "ussdcnt",
      },
      {
        Header: "USSD Amount",
        accessor: "ussdamt",
      },
    ]
  }
};
export default rprbi10;